import { useCallback, useEffect } from "react";
import { useAuthStore } from "../contexts/AuthContext";
import { analyticsFunctions } from "./config";

export function useTrack() {
    const { track } = analyticsFunctions;
    const { user, selectedAccount } = useAuthStore();

    return useCallback((event, options = {}) => {
        return track(event, {
            user,
            account: selectedAccount,
            ...options
        })
    }, [user, selectedAccount, track])
}

/**
 * A hook that issues tracking events when the user visits/opens the component and leaves it.
 * 
 * @param {String} visitEventName The name of the event to call when the user visits the page.
 * @param {String} leaveEventName (Optional) The name of the event to call when the user leaves the page.
 * @param {Object} properties (Optional) Properties unique to this component to add to both events
 */

export function useTrackOpenClose(visitEventName, leaveEventName, properties = {}) {
    const track = useTrack();

    return useEffect(()=>{
        if (visitEventName){
            track(visitEventName, properties);
        }
        
        if (leaveEventName) {
            return ()=>{
                track(leaveEventName, properties);
            }
        }

      }, [track])
}
